export const DD_OPTIONS = ["None", ...Array.from({ length: 31 }, (_, i) => String(i + 1))];
export const MM_OPTIONS = [
  "None",
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
  "January-February", "February-March", "March-April", "April-May",
  "May-June", "June-July", "July-August", "August-September",
  "September-October", "October-November", "November-December", "December-January",
  "Fall", "Winter", "Spring", "Summer"
];export const SINGLE_MONTH_OPTIONS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
export const MONTH_NAME_TO_NUMBER = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12",
};
